import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApiResponse,
  EventTypeDownloadResponse,
  EventTypeUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { EventTypeResponse } from "../../models/responseModels/eventTypeResponse";
import {
  AddEventTypeRequest,
  UpdateEventTypeRequest,
} from "../../models/requestModels/eventTypeRequest";

type InitialState = {
  isLoading: boolean;
  eventTypeList: EventTypeResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  eventTypeList: [],
  errorMessage: null,
};

export const getEventTypeList = createAsyncThunk<EventTypeUIResponse>(
  "eventType/eventTypeResponse",
  async () => {
    const response = await agent.EventTypeAgent.getEventTypeList();
    return response;
  }
);

export const downloadEventTypeDataToCsv = createAsyncThunk<
  EventTypeDownloadResponse,
  EventTypeResponse[]
>("eventType/downloadCsv", async (eventTypesData: EventTypeResponse[]) => {
  const response = await agent.EventTypeAgent.eventTypeCsvDownload(
    eventTypesData
  );
  return response;
});

export const downloadEventTypeDataToXlsx = createAsyncThunk<
  Blob,
  EventTypeResponse[]
>("eventType/downloadXlsx", async (eventTypesData: EventTypeResponse[]) => {
  const response = await agent.EventTypeAgent.eventTypeXlsxDownload(
    eventTypesData
  );
  return response;
});

export const updateEventType = createAsyncThunk<
  ApiResponse,
  UpdateEventTypeRequest
>(
  "eventType/updateEventType",
  async (updateEventTypeRequest: UpdateEventTypeRequest) => {
    const response = await agent.EventTypeAgent.updateEventType(
      updateEventTypeRequest
    );
    return response;
  }
);

export const addEventType = createAsyncThunk<ApiResponse, AddEventTypeRequest>(
  "eventType/addEventType",
  async (addEventTypeRequest: AddEventTypeRequest) => {
    const response = await agent.EventTypeAgent.addEventType(
      addEventTypeRequest
    );
    return response;
  }
);

const eventTypeSlice = createSlice({
  name: "eventType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEventTypeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEventTypeList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.eventTypeList = action.payload.data;
        } else {
          state.eventTypeList = [];
        }
      })
      .addCase(getEventTypeList.rejected, (state, action) => {
        state.isLoading = false;
        state.eventTypeList = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default eventTypeSlice.reducer;
